import { useRecoilState } from "recoil";
import { kpiIdOrder } from "./kpiIds";
import { useEffect, useState } from "react";
import { Kpi, KpiWithGroupId } from "../Alert/Filter/FilterType";
import { useKpiCatalog } from "../services/Kpi";
import { useIntl } from "react-intl";
import {
  ColumnGroupedDnd,
  DragDropPerTypeContainer,
  GroupedKpis,
} from "../components/DragDropPerType";
import { kpiSelectedAtom } from "./atom";

export type ColumnDnd = {
  name: string;
  items: Kpi[];
};

export const AlertDragDrop = ({ onClose }: { onClose: () => void }) => {
  const [leftColumn, setLeftColumn] = useState<ColumnGroupedDnd>();
  const [rightColumn, setRightColumn] = useState<ColumnDnd>();
  const query = useKpiCatalog();
  const [kpiSelected, setKpiSelected] = useRecoilState(kpiSelectedAtom);
  const intl = useIntl();

  useEffect(() => {
    if (query.data) {
      setLeftColumn({
        name: intl.formatMessage({ id: "KPIS_AVAILABLE" }),
        items:
          (query.data?.types.map((kpiType) => ({
            id: kpiType.id,
            label: kpiType.label,
            kpiList: kpiType.children?.reduce((result, kpi) => {
              if (!kpiSelected.find((value) => value.id === kpi.id))
                result.push({ ...kpi, groupId: kpiType.id });
              return result;
            }, [] as KpiWithGroupId[]),
          })) as GroupedKpis[]) || [],
      });

      const kpiList = query.data?.types.reduce((result, kpiType) => {
        return [
          ...result,
          ...(kpiType.children?.map((kpi) => ({
            ...kpi,
            groupId: kpiType.id,
          })) || []),
        ];
      }, [] as KpiWithGroupId[]);

      const kpiSelectedColumn = kpiSelected.reduce((result, kpi) => {
        const currentKpi = kpiList.find((val) => kpi.id === val.id);
        if (currentKpi) result.push({ ...currentKpi, order: kpi.order });
        return result;
      }, [] as KpiWithGroupId[]);

      kpiSelectedColumn.sort((a, b) => a.order - b.order);

      setRightColumn({
        name: intl.formatMessage({ id: "KPIS_DISPLAYED" }),
        items: kpiSelectedColumn || [],
      });
    }
  }, [query.data, kpiSelected, intl]);

  const handleSubmit = (listKpisId: kpiIdOrder[]) => {
    setKpiSelected((prevKpiList) =>
      listKpisId.map((kpi) => {
        const columnWidth = prevKpiList.find(
          (prevKpi) => prevKpi.id === kpi.id
        )?.columnWidth;
        return { ...kpi, columnWidth: columnWidth };
      })
    );
    onClose();
  };

  return leftColumn && rightColumn ? (
    <DragDropPerTypeContainer
      firstColumn={leftColumn}
      secondColumn={rightColumn}
      onSubmit={handleSubmit}
    />
  ) : null;
};
